import { Link } from "react-router-dom";

import { AppBar, Box, Container, Hidden } from "@material-ui/core";

import { publicPath } from "@ip-utils";

import Department from "./Department";
import Navigation from "./Navigation";
import User from "./User";

export default function Header() {
  return (
    <AppBar color="inherit" position="static">
      <Box bgcolor="iglu.denimBlue95" color="common.white" displayPrint="none">
        <Container>
          <Box
            alignItems="center"
            display="flex"
            paddingBottom={3}
            paddingTop={3}
          >
            <Link to="/">
              <Box
                alt="iglu"
                component="img"
                display="block"
                height={32}
                width={100}
                src={publicPath("/media/iglu-white.svg")}
              />
            </Link>
            <Hidden xsDown>
              <Box marginLeft={3}>
                <Department />
              </Box>
            </Hidden>
            <Box
              alignItems="center"
              display="flex"
              flexGrow={1}
              justifyContent="flex-end"
            >
              <Navigation mobile />
              <User />
            </Box>
          </Box>
        </Container>
      </Box>
      <Navigation />
    </AppBar>
  );
}
